import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import SiteFooter from "./components/SiteFooter";
import Bazi from "./components/bazi/Bazi";
import BZChart from "./components/bazi/BZChart";
import BaziHistory from "./components/bazi/BaziHistory";
import BaziDetail from "./components/bazi/BaziDetail";

function App_bazi() {
  const [currentView, setCurrentView] = useState("bazi");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar
        currentView={currentView}
        setCurrentView={setCurrentView}
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
      
      <main className="flex-grow">
        <Routes>
            <Route path="/index" element={<Bazi />} />
            <Route path="/history" element={<BaziHistory />} />
            <Route path="/baziDetail" element={<BaziDetail />} />
            <Route path="/bachart" element={<BZChart />} />          
        </Routes>
      </main>     
      <SiteFooter />
    </div>
  );
}

export default App_bazi;